import * as actionTypes from './actionTypes'
import * as API from '../api/home'

export const getAllHome = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.HOME_PAGE_REQUEST, payload: data})
        return API.getAllHome(data)
            .then(response => {            	
            	dispatch({type: actionTypes.HOME_PAGE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.HOME_PAGE_ERROR, payload:error})    
            })
    }
}


export const getAllHomeLink = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.HOME_PAGE_REQUEST, payload: data})
        return API.getAllHomeLinkDin(data)
            .then(response => {             
                dispatch({type: actionTypes.HOME_PAGE_SUCCESS, payload: response})                
            })
            .catch(error => {
                console.log("error", error);
                dispatch({type: actionTypes.HOME_PAGE_ERROR, payload:error})    
            })
    }
}

export const getJobProviderCountAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.DASHBOARD_DATA_COUNT_REQUEST, payload: data})
        return API.getJobProviderCountsApi(data)
            .then(response => {             
                dispatch({type: actionTypes.DASHBOARD_DATA_COUNT_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.DASHBOARD_DATA_COUNT_ERROR, payload:error})    
            })
    }
}

export const getJobProviderAnalysisAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.DASHBOARD_GRAPH_ANALYTICS_REQUEST, payload: data})
        return API.getJobProviderAnalysisApi(data)
            .then(response => {             
                dispatch({type: actionTypes.DASHBOARD_GRAPH_ANALYTICS_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.DASHBOARD_GRAPH_ANALYTICS_ERROR, payload:error})    
            })
    }
}

export const getAllBlogsAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.USER_BLOG_REQUEST, payload: data})
        return API.getAllBlog(data)
            .then(response => {             
                dispatch({type: actionTypes.USER_BLOG_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.USER_BLOG_ERROR, payload:error})    
            })
    }
}

export const getRecruiterView = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.USER_RECRUITER_VIEW_REQUEST, payload: data})
        return API.getRecruiter(data)
            .then(response => {             
                dispatch({type: actionTypes.USER_RECRUITER_VIEW_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.USER_RECRUITER_VIEW_ERROR, payload:error})    
            })
    }
}




// WEBPACK FOOTER //
// ./src/actions/home.js